export default "__VITE_ASSET__5e24062c__"